import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cn } from "@/lib/utils";

/**
 * TB brand Popover — transient anchored view, non-modal. For desktop and wide viewports; on
 * mobile prefer a sheet.
 */
export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;
export const PopoverClose = PopoverPrimitive.Close;

export const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    /**
     * Draws no arrow. Radix adds the arrow's height to the offset, so a panel meant to sit exactly
     * `sideOffset` under its trigger — the host panel's facets, which the prototype draws as a
     * plain box 8px below the chip — has to go without it.
     */
    hideArrow?: boolean;
  }
>(({ className, align = "center", sideOffset = 8, hideArrow = false, children, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        "z-50 w-60 rounded-[var(--tb-radius-sm)] border border-[var(--tb-border)] bg-tb-white p-4 text-[var(--fg)] shadow-[var(--tb-shadow-lg)] outline-none",
        "data-[state=open]:[animation:tb-fade-in_150ms_ease-out]",
        className,
      )}
      {...props}
    >
      {children}
      {hideArrow ? null : <PopoverPrimitive.Arrow className="fill-tb-white" width={12} height={7} />}
    </PopoverPrimitive.Content>
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
